import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppParameterService } from './logic/app-parameter.service';
import { AppParameterLogicService } from './logic/app-parameter/app-parameter-logic.service';
import { AppParameterDaoService } from './dao/app-parameter-dao.service';
import { AppParameterStorageDaoService } from './dao/app-parameter-dao/app-parameter-storage-dao.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: AppParameterService, useClass: AppParameterLogicService },
    { provide: AppParameterDaoService, useClass: AppParameterStorageDaoService }
  ]
})
export class AppParameterModule {}
